export const FC_SPRING_EASE = 'cubic-bezier(0.25, 0, 0, 1)'
